import { Component } from '@angular/core'

@Component({
  standalone: true,
  selector: 'customer-portal-app-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss']
})
export class DividerComponent {

}
